import { render } from "./PageGallery.vue?vue&type=template&id=b8281b22&scoped=true"
import script from "./PageGallery.vue?vue&type=script&lang=js"
export * from "./PageGallery.vue?vue&type=script&lang=js"

import "./PageGallery.vue?vue&type=style&index=0&id=b8281b22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8281b22"]])

export default __exports__